import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import ForgottenPassword from '../views/ForgottenPassword';
import ResetPassword from '../views/ResetPassword';
import Register from '../views/Register.vue';
import Courses from '../views/Courses.vue';
import CourseDetails from '../views/CourseDetails.vue';
import CourseDetailsModule from '../views/CourseDetailsModule.vue';
import NewCourse from '../views/NewCourse.vue';
import NewCourseChoice from '../components/NewCourseChoice.vue';
import FAQ from '../views/FAQ.vue';
import About from '../pages/About.vue';
// import Forum from '../views/Forum.vue';
// import ForumThread from '../views/ForumThread.vue';
import InstructorProfile from '../views/InstructorProfile.vue';
import InstructorCourses from '../views/InstructorCourses.vue';
import Instructors from '../views/Instructors.vue';
import Seminars from '../views/Seminars.vue';
import Students from '../views/Students.vue';
import Profession from '../views/Profession.vue';
import StudentProfession from '../views/StudentProfession.vue';
import Documentation from '../views/Documentation.vue';
import Modules from '../views/Modules.vue';
import Invite from '../views/Invite.vue';
import ConfirmInvite from '../views/ConfirmInvite.vue';
import NavBar from '../components/NavBar.vue';
import NavBarTop from '../components/NavBarTop.vue';
import EditableTextField from '../components/EditableTextField.vue';
import CourseOnboarding from '../components/CourseOnboarding.vue';
import WebinarSection from '../components/WebinarSection.vue';

import userInterface from './user-interface';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret, faDesktop } from '@fortawesome/free-solid-svg-icons';

import store from '@/store';

Vue.use(VueRouter);

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('nav-bar', NavBar);
Vue.component('nav-bar-top', NavBarTop);
Vue.component('editable-text-field', EditableTextField);

library.add(faUserSecret, faDesktop);
// roles: 0 public, 1 student, 2 instructor, 3 editor
const routes = [
  {
    path: '/',
    name: 'Profession',
    component: Profession,
    icon: 'fas fa-home',
    inNav: false,
    role: 0,
  },
  {
    path: '/instructor-profile',
    name: 'Profile',
    component: InstructorProfile,
    icon: 'fas fa-circle-user',
    inNav: false,
    role: 2,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    icon: 'fas fa-home',
    inNav: true,
    role: 1,
  },
  {
    path: '/documentation',
    name: 'Documentation',
    component: Documentation,
    icon: 'fas fa-home',
    inNav: false,
    role: 0,
  },
  {
    path: '/about',
    name: 'Impressum',
    component: About,
    icon: 'fas fa-home',
    inNav: false,
    role: 0,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    icon: 'fas fa-sign-in',
    inNav: localStorage.getItem('user') ? false : true,
    role: 0,
    // beforeEnter: (to, from, next) => {
    //   console.log('beforeEnter', to.path, from.path);
    //   if (to.name !== 'Login') {
    //     next({ path: '/login', replace: true });
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: '/forgotpassword',
    name: 'ForgotPassword',
    component: ForgottenPassword,
    icon: 'fa-solid fa-user-secret',
    inNav: false,
    role: 0,
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword,
    icon: 'fa-solid fa-user-secret',
    inNav: false,
    role: 0,
  },
  {
    path: '/webinar',
    name: 'Webinar',
    component: WebinarSection,
    icon: faDesktop,
    inNav: true,
    role: 0,
  },
  {
    path: '/onboarding',
    name: 'Onboarding',
    component: CourseOnboarding,
    icon: faUserSecret,
    inNav: true,
    role: 2,
  },
  {
    path: '/invite/:id',
    name: 'Invite',
    component: Invite,
    icon: 'fa-solid fa-user-secret',
    inNav: false,
    role: 1,
  },
  {
    path: '/invite/:id/:userId',
    name: 'Invite',
    component: ConfirmInvite,
    icon: 'fa-solid fa-user-secret',
    inNav: false,
    role: 2,
  },
  {
    path: '/courses',
    name: 'Kurse',
    component: Courses,
    icon: 'fas fa-graduation-cap',
    inNav: true,
    role: 0,
  },
  {
    path: '/courses/:id',
    name: 'CourseDetails',
    component: CourseDetails,
    props: true,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
    meta: {
      permission: 'Public',
      authRequired: false,
    },
  },
  {
    path: '/courses/:id/:sectionRouteId/:moduleId',
    name: 'CourseDetailsModule',
    component: CourseDetailsModule,
    props: true,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
    meta: {
      permission: 'Public',
      authRequired: false,
    },
  },
  /*   {
    path: '/courses/feuerwehr/:id',
    name: 'CourseDetails',
    component: CourseDetails,
    props: true,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/courses/polizei/:id',
    name: 'CourseDetails',
    component: CourseDetails,
    props: true,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
    meta: {
      authRequired: true,
    },
  }, */
  {
    path: '/new-course',
    name: 'Neue Kurse',
    component: NewCourse,
    props: true,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 2,
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: FAQ,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
  },
  {
    path: '/newcoursechoice',
    name: 'New Course Choice',
    component: NewCourseChoice,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 2,
  },
  // {
  //   path: '/forum',
  //   name: 'Forum',
  //   component: Forum,
  //   icon: 'fas fa-graduation-cap',
  //   inNav: false,
  //   role: 1,
  // },
  // {
  //   path: '/forum-thread',
  //   name: 'Forum Thread',
  //   component: ForumThread,
  //   icon: 'fas fa-graduation-cap',
  //   inNav: false,
  //   role: 1,
  // },
  {
    path: '/profession',
    name: 'Profession',
    component: Profession,
    icon: 'fas fa-user',
    inNav: false,
    role: 0,
  },
  {
    path: '/studentprofession',
    name: 'Student Profession',
    component: StudentProfession,
    icon: 'fas fa-user',
    inNav: false,
    role: 0,
  },
  {
    path: '/instructor-courses',
    name: 'Meine Kurse',
    component: InstructorCourses,
    icon: 'fas fa-chalkboard-teacher',
    inNav: true,
    role: 2,
  },
  {
    path: '/instructors',
    name: 'Instructors',
    component: Instructors,
    icon: 'fas fa-chalkboard-teacher',
    inNav: false,
    role: 0,
  },
  {
    path: '/seminars',
    name: 'Seminars',
    component: Seminars,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 0,
  },
  {
    path: '/students',
    name: 'Students',
    component: Students,
    icon: 'fas fa-graduation-cap',
    inNav: false,
    role: 2,
  },
  {
    path: '/modules',
    name: 'Contentmodule',
    component: Modules,
    icon: 'fas fa-chalkboard',
    inNav: true,
    role: 2,
  },
  ...userInterface,
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    role: 0,
    component: () => import('@/pages/404.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  //console.log(store.getters.courseCategories);
  try {
    const desiredPage = routes.find((route) => {
      return route.name == to.name;
    });
    /*     console.log('from router', from.name);
    console.log('desiredPage route.name', desiredPage);
    console.log('to name router', to.name);
    console.log('routername', router.name); */

    let user = localStorage.getItem('user')
      ? localStorage.getItem('user')
      : null;
    user = JSON.parse(user);

    //const userData = JSON.parse(localStorage.getItem('user'));
    //const userRole = userData && userData.rolle ? userData.rolle : null;

    //    Page is public -> to.path.includes('public')

    if (desiredPage.role === 0) {
      store.dispatch('setPastPath', from.path);
      console.log('beforeEnter desiredPage Role', to.path, from.path);
      //console.log('page is public.', to.params.id);
      // next(this.$route.query.redirect || '/');
      next();
    } else if (!user) {
      next('/login');
    } else {
      if (user.role.name >= desiredPage.role) {
        console.log('authorized.');
        //router.push(router.query.redirect || '/');
        next();
      } else {
        console.log('not authorized.');
        next('/not-allowed');
      }
    }
  } catch (error) {
    console.log('Error beforeEach Router', error);
  }
  /*   var courseRoleFeuerwehr = localStorage.getItem('Feuerwehr');
  var courseRolePolizei = localStorage.getItem('Polizei');

  console.log('Feuerwehr', courseRoleFeuerwehr);
  console.log('Polizei', courseRolePolizei);
  console.log('UserRole', userRole);

  if (userRole === 'Feuerwehr' && courseRoleFeuerwehr) {
    console.log('Du bist die Feuerwehr und darfst das sehen');
    next();
  }

  if (userRole === 'Polizei' && courseRolePolizei) {
    console.log('Du bist die Polizei und darfst das sehen');
    next();
  } */
});

export default router;
